// extracted by mini-css-extract-plugin
export default {"headerContainer":"passwordresetpage_headerContainer__FshPC"};